// extracted by mini-css-extract-plugin
export default {"admin__rules":"admin-rules_admin__rules__SawmE","rules__list":"admin-rules_rules__list__OD3Zj"};